// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['zh_CN']  = {
  "name": "zh_CN",
  "day": {
    "abbrev": [
      "日",
      "一",
      "二",
      "三",
      "四",
      "五",
      "六"
    ],
    "full": [
      "星期日",
      "星期一",
      "星期二",
      "星期三",
      "星期四",
      "星期五",
      "星期六"
    ]
  },
  "month": {
    "abbrev": [
      " 1月",
      " 2月",
      " 3月",
      " 4月",
      " 5月",
      " 6月",
      " 7月",
      " 8月",
      " 9月",
      "10月",
      "11月",
      "12月"
    ],
    "full": [
      "一月",
      "二月",
      "三月",
      "四月",
      "五月",
      "六月",
      "七月",
      "八月",
      "九月",
      "十月",
      "十一月",
      "十二月"
    ]
  },
  "meridiem": [
    "上午",
    "下午"
  ],
  "date": "%Y年%m月%d日",
  "time24": "%H时%M分%S秒",
  "dateTime": "%Y年%m月%d日 %A %H时%M分%S秒",
  "time12": "%p %I时%M分%S秒",
  "full": "%Y年 %m月 %d日 %A %H:%M:%S %Z"
}

